import {
  Breadcrumb,
  BreadcrumbItem,
  Col,
  Container,
  Row,
} from '@dataesr/react-dsfr';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import BannerNational from '../../../components/BannerNational';
import BSOChart from '../../../components/Charts';
import DataCardSection from '../../../components/DataCardsSection';
import Glossary from '../../../components/Glossary';
import GlossaryFormattedMessage from '../../../components/Glossary/GlossaryFormattedMessage';
import GraphNavigation from '../../../components/GraphNavigation';
import GraphContent from '../../../components/GraphNavigation/GraphContent';
import GraphItem from '../../../components/GraphNavigation/GraphItem';
import QuestionSection from '../../../components/question-section';
import ScrollTop from '../../../components/ScrollTop';
import GlossaryEntries from '../../../translations/glossary.json';
import { mobileButtonLabel } from '../../../utils/constants';
import { getCSSValue, isInProduction } from '../../../utils/helpers';
import useLang from '../../../utils/Hooks/useLang';

export default function NationalPublications() {
  const { lang } = useLang();
  const { pathname } = useLocation();
  const intl = useIntl();
  const greenBg = getCSSValue('--green-50');
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    setRendered(true);
  }, []);

  return (
    <Container fluid className='page'>
      <BannerNational
        selected='url.publications.general'
        title='app.baro-national.publications.title'
        iconId='icon-bsso-28'
      />
      <ScrollTop />
      <section className='content'>
        <Row>
          <Container>
            <Row>
              <Col n='12'>
                {/* <Breadcrumb>
                  <BreadcrumbItem href='/' className='underline'>
                    {intl.formatMessage({
                      id: 'app.header.nav.baro-national-accueil',
                    })}
                  </BreadcrumbItem>
                  <BreadcrumbItem href='#' className='bold'>
                    {intl.formatMessage({
                      id: 'app.baro-national.publications.title',
                    })}
                  </BreadcrumbItem>
                </Breadcrumb>
                <h1 className='contentTitle marianne-bold mb-32'>
                  <FormattedMessage id='app.baro-national.publications.title' />
                </h1> */}
                <p>
                  <GlossaryFormattedMessage
                    intlKey='app.baro-national.intro'
                    glossaryKeys={['acces-ouvert', 'publication-fr']}
                  />
                </p>
              </Col>
              <Col n='12'>
                <DataCardSection lang={lang} />
              </Col>
            </Row>
          </Container>
          {rendered && <Glossary entries={GlossaryEntries} />}
        </Row>
        <Row>
          <GraphNavigation mobileTitleIntl={mobileButtonLabel[lang][pathname]}>
            {/* Général */}
            <GraphItem
              mainLabel={intl.formatMessage({ id: 'app.publi.general' })}
              paths={['/publications/general']}
              links={[
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.go-to-page',
                  }),
                  href: {
                    en: '/publications/general?id=general.dynamique-ouverture',
                    ja: '/publications/general?id=general.dynamique-ouverture',
                    fr: '/publications/general?id=general.dynamique-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.dynamique',
                  }),
                  href: {
                    en: '/publications/general?id=general.dynamique-ouverture',
                    ja: '/publications/general?id=general.dynamique-ouverture',
                    fr: '/publications/general?id=general.dynamique-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.voies',
                  }),
                  href: {
                    en: '/publications/general?id=general.voies-ouverture',
                    ja: '/publications/general?id=general.voies-ouverture',
                    fr: '/publications/general?id=general.voies-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.genres',
                  }),
                  href: {
                    en: '/publications/general?id=general.genres-ouverture',
                    ja: '/publications/general?id=general.genres-ouverture',
                    fr: '/publications/general?id=general.genres-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.langues',
                  }),
                  href: {
                    en: '/publications/general?id=general.langues-ouverture',
                    ja: '/publications/general?id=general.langues-ouverture',
                    fr: '/publications/general?id=general.langues-ouverture',
                  },
                },
                // {
                //   label: intl.formatMessage({
                //     id: 'app.publi.navigation.hal',
                //   }),
                //   href: {
                //     en: '/publications/general?id=general.hal',
                //     ja: '/publications/general?id=general.hal',
                //     fr: '/publications/general?id=general.hal',
                //   },
                // },
                // {
                //   label: intl.formatMessage({
                //     id: 'app.publi.navigation.lpr',
                //   }),
                //   href: {
                //     en: '/publications/general?id=general.lpr',
                //     ja: '/publications/general?id=general.lpr',
                //     fr: '/publications/general?id=general.lpr',
                //   },
                // },
              ]}
            >
              <GraphContent>
                <QuestionSection
                  intlKey='app.national-publi.general.dynamique-ouverture'
                  glossaryKeys={['embargo', 'barriere-mobile']}
                  backgroundColor={greenBg}
                  anchorId='general.dynamique-ouverture'
                >
                  <BSOChart id='publi.general.dynamique-ouverture.chart-taux-ouverture' />
                  <BSOChart id='publi.general.dynamique-ouverture.chart-evolution-proportion' />
                </QuestionSection>
                <QuestionSection
                  intlKey='app.national-publi.general.voies-ouverture'
                  glossaryKeys={['archive-ouverte']}
                  backgroundColor={greenBg}
                  anchorId='general.voies-ouverture'
                >
                  <BSOChart id='publi.general.voies-ouverture.chart-repartition-publications' />
                  <BSOChart id='publi.general.voies-ouverture.chart-repartition-taux' />
                </QuestionSection>
                <QuestionSection
                  intlKey='app.national-publi.general.genres-ouverture'
                  backgroundColor={greenBg}
                  anchorId='general.genres-ouverture'
                  glossaryKeys={['preprints']}
                >
                  <BSOChart id='publi.general.genres-ouverture.chart-repartition-genres' />
                  <BSOChart id='publi.general.genres-ouverture.chart-evolution-proportion' />
                </QuestionSection>
                <QuestionSection
                  intlKey='app.national-publi.general.langues-ouverture'
                  backgroundColor={greenBg}
                  anchorId='general.langues-ouverture'
                >
                  <BSOChart id='publi.general.langues-ouverture.chart-repartition-publications' />
                  {/* <BSOChart
                    id='publi.general.langues.chart-publications-by-year'
                    isDisplayed={!isInProduction()}
                  /> */}
                </QuestionSection>
                {/*
                <QuestionSection
                  anchorId='general.hal'
                  backgroundColor={greenBg}
                  intlKey='app.national-publi.general.hal'
                >
                  <iframe
                    height={lang === 'fr' ? '788' : '765'}
                    id='publi.general.dynamique-ouverture.chart-taux-ouverture'
                    src={`../integration/${lang}/publi.general.dynamique-ouverture.chart-taux-ouverture?useHalId=true`}
                    title='publi.general.dynamique-ouverture.chart-taux-ouverture'
                    width='100%'
                  />
                </QuestionSection>
                <QuestionSection
                  intlKey='app.national-publi.general.lpr'
                  backgroundColor={greenBg}
                  anchorId='general.lpr'
                >
                  <BSOChart id='publi.general.dynamique-ouverture.chart-taux-ouverture-article' />
                </QuestionSection>
                */}
              </GraphContent>
            </GraphItem>

            {/* Disciplines */}
            <GraphItem
              paths={['/publications/disciplines', '/publications/fields']}
              mainLabel={intl.formatMessage({
                id: 'app.publi.disciplines',
              })}
              links={[
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.go-to-page',
                  }),
                  href: {
                    en: '/publications/fields?id=disciplines.dynamique-ouverture',
                    ja: '/publications/fields?id=disciplines.dynamique-ouverture',
                    fr: '/publications/disciplines?id=disciplines.dynamique-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.disciplines.dynamique',
                  }),
                  href: {
                    en: '/publications/fields?id=disciplines.dynamique-ouverture',
                    ja: '/publications/fields?id=disciplines.dynamique-ouverture',
                    fr: '/publications/disciplines?id=disciplines.dynamique-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.disciplines.voies',
                  }),
                  href: {
                    en: '/publications/fields?id=disciplines.voies-ouverture',
                    ja: '/publications/fields?id=disciplines.voies-ouverture',
                    fr: '/publications/disciplines?id=disciplines.voies-ouverture',
                  },
                },
              ]}
            >
              <GraphContent>
                <QuestionSection
                  intlKey='app.national-publi.disciplines.dynamique-ouverture'
                  backgroundColor={greenBg}
                  anchorId='disciplines.dynamique-ouverture'
                >
                  <BSOChart id='publi.disciplines.dynamique-ouverture.chart-taux-ouverture' />
                  {/* <BSOChart id='publi.disciplines.dynamique-ouverture.chart-evolution-taux-ouverture' /> */}
                </QuestionSection>

                <QuestionSection
                  intlKey='app.national-publi.disciplines.voies-ouverture'
                  glossaryKeys={['archive-ouverte', 'pmc']}
                  backgroundColor={greenBg}
                  anchorId='disciplines.voies-ouverture'
                >
                  <BSOChart id='publi.disciplines.voies-ouverture.chart-repartition-publications' />
                  {/* <BSOChart id='publi.disciplines.voies-ouverture.chart-evolution-comparaison-types-hebergement' /> */}
                </QuestionSection>
              </GraphContent>
            </GraphItem>

            {/* Editeurs */}
            <GraphItem
              paths={['/publications/editeurs', '/publications/publishers']}
              mainLabel={intl.formatMessage({ id: 'app.publi.editeurs' })}
              links={[
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.go-to-page',
                  }),
                  href: {
                    en: '/publications/publishers?id=publishers.dynamique-ouverture',
                    ja: '/publications/publishers?id=publishers.dynamique-ouverture',
                    fr: '/publications/editeurs?id=publishers.dynamique-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.editeurs.dynamique',
                  }),
                  href: {
                    en: '/publications/publishers?id=publishers.dynamique-ouverture',
                    ja: '/publications/publishers?id=publishers.dynamique-ouverture',
                    fr: '/publications/editeurs?id=publishers.dynamique-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.editeurs.modele',
                  }),
                  href: {
                    en: '/publications/publishers?id=publishers.type-ouverture',
                    ja: '/publications/publishers?id=publishers.type-ouverture',
                    fr: '/publications/editeurs?id=publishers.type-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.editeurs.politique',
                  }),
                  href: {
                    en: '/publications/publishers?id=publishers.politiques-ouverture',
                    ja: '/publications/publishers?id=publishers.politiques-ouverture',
                    fr: '/publications/editeurs?id=publishers.politiques-ouverture',
                  },
                },
                // {
                //   label: intl.formatMessage({
                //     id: 'app.publi.navigation.editeurs.revues',
                //   }),
                //   href: {
                //     en: '/publications/publishers?id=publishers.poids-revues',
                //     ja: '/publications/publishers?id=publishers.poids-revues',
                //     fr: '/publications/editeurs?id=publishers.poids-revues',
                //   },
                // },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.editeurs.licences',
                  }),
                  href: {
                    en: '/publications/publishers?id=publishers.repartition-licences',
                    ja: '/publications/publishers?id=publishers.repartition-licences',
                    fr: '/publications/editeurs?id=publishers.repartition-licences',
                  },
                },
                {
                  href: {
                    en: '/publications/publishers?id=publishers.couts-publication',
                    ja: '/publications/publishers?id=publishers.couts-publication',
                    fr: '/publications/editeurs?id=publishers.couts-publication',
                  },
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.editeurs.frais',
                  }),
                },
              ]}
            >
              <GraphContent>
                <QuestionSection
                  intlKey='app.national-publi.publishers.dynamique-ouverture'
                  backgroundColor={greenBg}
                  anchorId='publishers.dynamique-ouverture'
                >
                  <BSOChart id='publi.publishers.dynamique-ouverture.chart-taux-ouverture' />
                  <BSOChart id='publi.publishers.dynamique-ouverture.chart-evolution-proportion' />
                </QuestionSection>

                <QuestionSection
                  intlKey='app.national-publi.publishers.type-ouverture'
                  glossaryKeys={[
                    'apc',
                    'gold-full-apc',
                    'hybrid',
                    'diamond',
                    'barriere-mobile',
                  ]}
                  backgroundColor={greenBg}
                  anchorId='publishers.type-ouverture'
                >
                  <BSOChart id='publi.publishers.type-ouverture.chart-repartition-modeles' />
                  <BSOChart id='publi.publishers.type-ouverture.chart-evolution-repartition' />
                </QuestionSection>

                <QuestionSection
                  intlKey='app.national-publi.publishers.politiques-ouverture'
                  glossaryKeys={[
                    'loi-republique-numerique',
                    'archive-ouverte',
                    'embargo',
                    'hal',
                  ]}
                  backgroundColor={greenBg}
                  anchorId='publishers.politiques-ouverture'
                >
                  <BSOChart id='publi.publishers.politiques-ouverture.chart-classement' />
                  {/* <BSOChart id='publi.publishers.politiques-ouverture.chart-comparaison' /> */}
                </QuestionSection>

                {/* <QuestionSection
                  intlKey='app.national-publi.publishers.poids-revues'
                  glossaryKeys={['predatory', 'list-beall']}
                  backgroundColor={greenBg}
                  anchorId='publishers.poids-revues'
                >
                  <BSOChart
                    id='publi.publishers.poids-revues.chart-repartition'
                    isDisplayed={!isInProduction()}
                  />
                </QuestionSection> */}

                <QuestionSection
                  intlKey='app.national-publi.publishers.repartition-licences'
                  glossaryKeys={['licence']}
                  backgroundColor={greenBg}
                  anchorId='publishers.repartition-licences'
                >
                  <BSOChart id='publi.publishers.repartition-licences.chart-repartition' />
                  {/* <BSOChart id='publi.publishers.repartition-licences.chart-classement' /> */}
                </QuestionSection>

                <QuestionSection
                  intlKey='app.national-publi.publishers.couts-publication'
                  backgroundColor={greenBg}
                  glossaryKeys={['apc', 'diamond', 'debusqapc']}
                  anchorId='publishers.couts-publication'
                >
                  {/* <BSOChart
                    id='publi.publishers.couts-publication.chart-depenses-estimees'
                    isDisplayed={!isInProduction()}
                  /> */}
                  <BSOChart id='publi.publishers.couts-publication.chart-distribution' />
                  {/* <BSOChart
                    id='publi.publishers.couts-publication.chart-distribution-par-annee'
                    isDisplayed={!isInProduction()}
                  /> */}
                </QuestionSection>
              </GraphContent>
            </GraphItem>

            {/* Archives ouvertes */}
            <GraphItem
              paths={['/publications/archives', '/publications/repositories']}
              mainLabel={intl.formatMessage({ id: 'app.publi.archives' })}
              links={[
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.go-to-page',
                  }),
                  href: {
                    en: '/publications/repositories?id=repositories.dynamique-ouverture',
                    ja: '/publications/repositories?id=repositories.dynamique-ouverture',
                    fr: '/publications/archives?id=repositories.dynamique-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.archives.dynamique',
                  }),
                  href: {
                    en: '/publications/repositories?id=repositories.dynamique-ouverture',
                    ja: '/publications/repositories?id=repositories.dynamique-ouverture',
                    fr: '/publications/archives?id=repositories.dynamique-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.archives.utilisees',
                  }),
                  href: {
                    en: '/publications/repositories?id=repositories.plus-utilisees',
                    ja: '/publications/repositories?id=repositories.plus-utilisees',
                    fr: '/publications/archives?id=repositories.plus-utilisees',
                  },
                },
                // {
                //   label: intl.formatMessage({
                //     id: 'app.publi.navigation.archives.depot',
                //   }),
                //   href: {
                //     en: '/publications/repositories?id=repositories.dynamique-depot',
                //     ja: '/publications/repositories?id=repositories.dynamique-depot',
                //     fr: '/publications/archives?id=repositories.dynamique-depot',
                //   },
                //   isDisplayed: !isInProduction(),
                // },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.archives.hal',
                  }),
                  href: {
                    en: '/publications/repositories?id=repositories.dynamique-hal',
                    ja: '/publications/repositories?id=repositories.dynamique-hal',
                    fr: '/publications/archives?id=repositories.dynamique-hal',
                  },
                },
              ]}
            >
              <GraphContent>
                <QuestionSection
                  intlKey='app.national-publi.repositories.dynamique-ouverture'
                  glossaryKeys={['archive-ouverte', 'anr', 'preprints']}
                  backgroundColor={greenBg}
                  anchorId='repositories.dynamique-ouverture'
                >
                  <BSOChart id='publi.repositories.dynamique-ouverture.chart-taux-ouverture' />
                  <BSOChart id='publi.repositories.dynamique-ouverture.chart-evolution-proportion' />
                </QuestionSection>

                <QuestionSection
                  intlKey='app.national-publi.repositories.plus-utilisees'
                  glossaryKeys={['pmc', 'hal']}
                  backgroundColor={greenBg}
                  anchorId='repositories.plus-utilisees'
                >
                  <BSOChart id='publi.repositories.plus-utilisees.chart-nombre-documents' />
                </QuestionSection>

                {/* <QuestionSection
                  intlKey='app.national-publi.repositories.dynamique-depot'
                  backgroundColor={greenBg}
                  anchorId='repositories.dynamique-depot'
                  isDisplayed={!isInProduction()}
                >
                  <BSOChart id='publi.repositories.dynamique-depot.chart-nombre-documents-depots' />
                </QuestionSection> */}

                <QuestionSection
                  intlKey='app.national-publi.repositories.dynamique-hal'
                  glossaryKeys={['hal']}
                  backgroundColor={greenBg}
                  anchorId='repositories.dynamique-hal'
                >
                  <BSOChart id='publi.repositories.dynamique-hal.chart-couverture-hal' />
                </QuestionSection>
              </GraphContent>
            </GraphItem>

            {/* Financements */}
            {/* <GraphItem
              paths={['/publications/financements', '/publications/fundings']}
              mainLabel={intl.formatMessage({
                id: 'app.publi.fundings',
              })}
              links={[
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.go-to-page',
                  }),
                  href: {
                    en: '/publications/fundings?id=fundings.chart-taux-ouverture',
                    ja: '/publications/fundings?id=fundings.chart-taux-ouverture',
                    fr: '/publications/financements?id=fundings.chart-taux-ouverture',
                  },
                },
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.fundings.anr',
                  }),
                  href: {
                    en: '/publications/fundings?id=fundings.chart-taux-ouverture',
                    ja: '/publications/fundings?id=fundings.chart-taux-ouverture',
                    fr: '/publications/financements?id=fundings.chart-taux-ouverture',
                  },
                },
              ]}
              isDisplayed={!isInProduction()}
            >
              <GraphContent isDisplayed={!isInProduction()}>
                <QuestionSection
                  anchorId='fundings.chart-taux-ouverture'
                  intlKey=''
                  backgroundColor={greenBg}
                >
                  <iframe
                    height='716'
                    id='publi.general.impact-financement.chart-taux-ouverture'
                    src={`../integration/${lang}/publi.general.impact-financement.chart-taux-ouverture?bsoLocalAffiliation=00rbzpz17&displayTitle=false`}
                    title='publi.general.impact-financement.chart-taux-ouverture'
                    width='100%'
                  />
                  <iframe
                    height='716'
                    id='publi.general.impact-financement.chart-taux-ouverture'
                    src={`../integration/${lang}/publi.general.impact-financement.chart-taux-ouverture?bsoLocalAffiliation=130012024&displayTitle=false`}
                    title='publi.general.impact-financement.chart-taux-ouverture'
                    width='100%'
                  />
                  <iframe
                    height='716'
                    id='publi.general.impact-financement.chart-business-model'
                    src={`../integration/${lang}/publi.general.impact-financement.chart-business-model?bsoLocalAffiliation=00rbzpz17&displayTitle=false`}
                    title='publi.general.impact-financement.chart-business-model'
                    width='100%'
                  />
                  <iframe
                    height='716'
                    id='publi.general.impact-financement.chart-business-model'
                    src={`../integration/${lang}/publi.general.impact-financement.chart-business-model?bsoLocalAffiliation=130012024&displayTitle=false`}
                    title='publi.general.impact-financement.chart-business-model'
                    width='100%'
                  />
                  <iframe
                    height='788'
                    id='publi.general.impact-financement.chart-repartition-financements'
                    src={`../integration/${lang}/publi.general.impact-financement.chart-repartition-financements?bsoLocalAffiliation=00rbzpz17&displayTitle=false`}
                    title='publi.general.impact-financement.chart-repartition-financements'
                    width='100%'
                  />
                  <iframe
                    height='812'
                    id='publi.general.impact-financement.chart-repartition-financements'
                    src={`../integration/${lang}/publi.general.impact-financement.chart-repartition-financements?bsoLocalAffiliation=130012024&displayTitle=false`}
                    title='publi.general.impact-financement.chart-repartition-financements'
                    width='100%'
                  />
                  <iframe
                    height='716'
                    id='publi.general.impact-financement.chart-repartition-taux'
                    src={`../integration/${lang}/publi.general.impact-financement.chart-repartition-taux?bsoLocalAffiliation=00rbzpz17&displayTitle=false`}
                    title='publi.general.impact-financement.chart-repartition-taux'
                    width='100%'
                  />
                  <iframe
                    height='716'
                    id='publi.general.impact-financement.chart-repartition-taux'
                    src={`../integration/${lang}/publi.general.impact-financement.chart-repartition-taux?bsoLocalAffiliation=130012024&displayTitle=false`}
                    title='publi.general.impact-financement.chart-repartition-taux'
                    width='100%'
                  />
                </QuestionSection>
              </GraphContent>
            </GraphItem> */}
            {/* A valider */}
            {/* <GraphItem
              paths={['/publications/a-decider', '/publications/to-be-decided']}
              mainLabel={intl.formatMessage({
                id: 'app.publi.to-be-decided',
              })}
              links={[
                {
                  label: intl.formatMessage({
                    id: 'app.publi.navigation.go-to-page',
                  }),
                  href: {
                    en: '/publications/to-be-decided?id=to-be-decided.international-collaborations',
                    ja: '/publications/to-be-decided?id=to-be-decided.international-collaborations',
                    fr: '/publications/a-decider?id=to-be-decided.international-collaborations',
                  },
                },
              ]}
              isDisplayed={!isInProduction()}
            >
              <GraphContent isDisplayed={!isInProduction()}>
                <QuestionSection
                  anchorId='to-be-decided.international-collaborations'
                  intlKey=''
                  backgroundColor={greenBg}
                >
                  <BSOChart id='publi.others.collaborations.international-collaborations' />
                  <BSOChart id='publi.others.retractions.chart-by-year' />
                  <BSOChart id='publi.others.retractions.chart-by-field' />
                  <BSOChart id='publi.others.retractions.chart-by-publisher' />
                  <BSOChart id='publi.others.retractions.chart-by-nature' />
                  <BSOChart id='publi.others.retractions.chart-by-reason' />
                  <BSOChart id='publi.publishers.dynamique-ouverture-journals.chart-taux-ouverture' />
                  <BSOChart id='publi.others.sources.publications-by-source' />
                  <BSOChart id='publi.others.hal-no-doi.hal-no-doi-by-field' />
                  <BSOChart id='publi.others.hal-no-doi.hal-no-doi-by-field-by-year' />
                </QuestionSection>
              </GraphContent>
            </GraphItem> */}
          </GraphNavigation>
        </Row>
      </section>
    </Container>
  );
}
